module.exports = __webpack_public_path__ + "static/media/theLightWeb.7acca6eb.png";